import { AxiosForLegacyBackend } from "../../../../utils/helpers/AxiosForLegacyBackend";

export interface StripePaymentCard {
  id: string;
  tokenizedCardNumber: string;
  expirationDate: string;
  cardType: string;
  creationDate: string;
  complete: boolean;
}

export interface SetupIntentResponse {
  clientSecret: string;
  setupIntentId: string;
}

export const fetchStripeCards = async (
  businessUserId: string
): Promise<StripePaymentCard[]> => {
  const response = await AxiosForLegacyBackend("/payment/cards2", {
    method: "GET",
    params: { businessUserId }
  });
  return response.data;
};

export const createSetupIntent = async (
  businessUserId: string
): Promise<SetupIntentResponse> => {
  const response = await AxiosForLegacyBackend("/payment/setup-intent", {
    method: "POST",
    params: { businessUserId }
  });
  return response.data;
};

export const confirmSetupIntent = async (
  setupIntentId: string,
  businessUserId: string
): Promise<void> => {
  await AxiosForLegacyBackend("/payment/confirm-setup-intent", {
    method: "POST",
    params: { setupIntentId, businessUserId }
  });
};

export const deleteCard = async (
  paymentMethodId: string,
  businessUserId: string
): Promise<void> => {
  await AxiosForLegacyBackend("/payment/delete-card", {
    method: "DELETE",
    params: { paymentMethodId, businessUserId }
  });
};
